interface SecureDesc {
  [key: string]: Array<string>
}

/* eslint-disable @typescript-eslint/no-unused-vars */
export const Secure = (actions?: SecureDesc) => {
  /* eslint-disable @typescript-eslint/no-unused-vars */
  return function(target: any, propertyKey: string, descriptor: PropertyDescriptor) {
    // console.log(target, propertyKey, descriptor)
  }
}

/* eslint-disable @typescript-eslint/no-unused-vars */
export const Role = (roles?: Array<RoleType>) => {
  /* eslint-disable @typescript-eslint/no-unused-vars */
  return function(target: any, propertyKey: string, descriptor: PropertyDescriptor) {
    // console.log(target, propertyKey, descriptor)
  }
}

/* eslint-disable @typescript-eslint/no-unused-vars */
export const IsRole = (roles?: Array<RoleType>) => {
  /* eslint-disable @typescript-eslint/no-unused-vars */
  return function(constructor: Function) {
    // todo
  }
}

export const GroupNames = {}

/**
 * 角色类型
 */
export enum RoleType {
  admin = '管理员',
  user = '学员',
  teacher = '教师'
}
